import React from 'react';

const SvgIcNoContract = props => (
  <svg viewBox="0 0 323.59 214.975" {...props}>
    <defs>
      <style>
        {
          '.ic_no_contract_svg__cls-1{fill:#5cc7da;opacity:.1}.ic_no_contract_svg__cls-2{fill:none;stroke:#63d8f1;stroke-miterlimit:10;stroke-width:5px}.ic_no_contract_svg__cls-3{fill:#63d8f1}.ic_no_contract_svg__cls-4{fill:#104eb2}'
        }
      </style>
    </defs>
    <g
      id="ic_no_contract_svg__Group_454"
      data-name="Group 454"
      transform="translate(-66.442 -213.371)"
    >
      <path
        id="ic_no_contract_svg__Path_186"
        data-name="Path 186"
        className="ic_no_contract_svg__cls-1"
        d="M28.216 106.927H12.951A13.014 13.014 0 010 93.938v-2.687A13.006 13.006 0 0112.951 78.3h15.228A12.982 12.982 0 0141.13 91.251v2.687a12.958 12.958 0 01-12.914 12.989z"
        transform="translate(66.442 182.876)"
      />
      <path
        id="ic_no_contract_svg__Path_187"
        data-name="Path 187"
        className="ic_no_contract_svg__cls-1"
        d="M784.979 425.789h-15.228a12.982 12.982 0 01-12.951-12.951v-2.687a12.982 12.982 0 0112.951-12.951h15.228a12.982 12.982 0 0112.951 12.951v2.687a13.006 13.006 0 01-12.951 12.951z"
        transform="translate(-407.898 -17.001)"
      />
      <path
        id="ic_no_contract_svg__Path_188"
        data-name="Path 188"
        className="ic_no_contract_svg__cls-1"
        d="M328.3 101.113h-32.177a94.079 94.079 0 00-152.128-58h-32.471a14.32 14.32 0 00-14.295 14.295 14.386 14.386 0 0011.906 14.108h23.14a15.642 15.642 0 0115.6 15.6v1.754a15.642 15.642 0 01-15.6 15.6h-46.28A14.32 14.32 0 0071.7 118.767a14.32 14.32 0 0014.295 14.295h24.67a94.072 94.072 0 00150.635 57.1 13.933 13.933 0 003.77.523h36.43a14.32 14.32 0 0014.295-14.295A14.32 14.32 0 00301.5 162.1H280a15.308 15.308 0 01-15.265-15.265v-2.015A15.308 15.308 0 01280 129.553h34.524a13.147 13.147 0 012.463.224h11.234a14.32 14.32 0 0014.295-14.295 14.249 14.249 0 00-14.216-14.369z"
        transform="translate(21.503 218.1)"
      />
      <circle
        id="ic_no_contract_svg__Ellipse_149"
        data-name="Ellipse 149"
        className="ic_no_contract_svg__cls-2"
        cx={5.76}
        cy={5.76}
        r={5.76}
        transform="translate(142.321 215.871)"
      />
      <circle
        id="ic_no_contract_svg__Ellipse_150"
        data-name="Ellipse 150"
        className="ic_no_contract_svg__cls-2"
        cx={8.203}
        cy={8.203}
        r={8.203}
        transform="translate(282.126 224.249)"
      />
      <circle
        id="ic_no_contract_svg__Ellipse_151"
        data-name="Ellipse 151"
        className="ic_no_contract_svg__cls-2"
        cx={5.76}
        cy={5.76}
        r={5.76}
        transform="translate(319.695 299.867)"
      />
      <path
        id="ic_no_contract_svg__Path_189"
        data-name="Path 189"
        className="ic_no_contract_svg__cls-3"
        d="M680.463 93.021h-8.9v-8.9a1.92 1.92 0 10-3.84 0v8.9h-8.9a1.92 1.92 0 100 3.84h8.9v8.9a1.92 1.92 0 103.84 0v-8.9h8.9a1.937 1.937 0 001.92-1.92 1.909 1.909 0 00-1.92-1.92z"
        transform="translate(-331.183 168.317)"
      />
      <path
        id="ic_no_contract_svg__Path_190"
        data-name="Path 190"
        className="ic_no_contract_svg__cls-3"
        d="M228.206 206.621h-8.9v-8.9a1.92 1.92 0 10-3.84 0v8.9h-8.946a1.92 1.92 0 100 3.84h8.9v8.9a1.92 1.92 0 103.84 0v-8.9h8.9a1.937 1.937 0 001.92-1.92 1.872 1.872 0 00-1.874-1.92z"
        transform="translate(-76.242 104.285)"
      />
      <path
        id="ic_no_contract_svg__Path_191"
        data-name="Path 191"
        className="ic_no_contract_svg__cls-3"
        d="M730.914 258.919l-4.887-4.887 4.887-4.887a1.481 1.481 0 10-2.095-2.094l-4.887 4.887-4.887-4.887a1.481 1.481 0 10-2.094 2.094l4.887 4.887-4.887 4.887a1.481 1.481 0 002.094 2.094l4.887-4.887 4.887 4.887a1.5 1.5 0 002.095 0 1.426 1.426 0 000-2.094z"
        transform="translate(-364.791 75.638)"
      />
      <g
        id="ic_no_contract_svg__Group_230"
        data-name="Group 230"
        transform="translate(166.829 378.247)"
      >
        <g id="ic_no_contract_svg__Group_229" data-name="Group 229">
          <path
            id="ic_no_contract_svg__Path_195"
            data-name="Path 195"
            className="ic_no_contract_svg__cls-3"
            d="M305.747 379.739H417.69c2.8 0 2.8-4.339 0-4.339H305.747c-2.8 0-2.8 4.339 0 4.339z"
            transform="translate(-303.65 -375.4)"
          />
        </g>
      </g>
      <g
        id="ic_no_contract_svg__Group_232"
        data-name="Group 232"
        transform="translate(293.234 378.247)"
      >
        <g id="ic_no_contract_svg__Group_231" data-name="Group 231">
          <path
            id="ic_no_contract_svg__Path_196"
            data-name="Path 196"
            className="ic_no_contract_svg__cls-3"
            d="M567.947 379.739h7.953c2.8 0 2.8-4.339 0-4.339h-7.954c-2.8 0-2.8 4.339 0 4.339z"
            transform="translate(-565.85 -375.4)"
          />
        </g>
      </g>
      <g
        id="ic_no_contract_svg__Group_234"
        data-name="Group 234"
        transform="translate(128.358 378.247)"
      >
        <g id="ic_no_contract_svg__Group_233" data-name="Group 233">
          <path
            id="ic_no_contract_svg__Path_197"
            data-name="Path 197"
            className="ic_no_contract_svg__cls-3"
            d="M225.947 379.739h24.973c2.8 0 2.8-4.339 0-4.339h-24.973c-2.8 0-2.8 4.339 0 4.339z"
            transform="translate(-223.85 -375.4)"
          />
        </g>
      </g>
      <g
        id="ic_no_contract_svg__agreement"
        transform="translate(186.924 271.441)"
      >
        <g
          id="ic_no_contract_svg__Group_494"
          data-name="Group 494"
          transform="translate(0 4)"
        >
          <g id="ic_no_contract_svg__Group_493" data-name="Group 493">
            <path
              id="ic_no_contract_svg__Path_491"
              data-name="Path 491"
              className="ic_no_contract_svg__cls-4"
              d="M72.472 4H1.61A1.611 1.611 0 000 5.61v91.8a1.611 1.611 0 001.61 1.61h70.862a1.611 1.611 0 001.61-1.61V5.61A1.611 1.611 0 0072.472 4zm-1.61 91.8H3.221V7.221h67.64z"
              transform="translate(0 -4)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_496"
          data-name="Group 496"
          transform="translate(27.378 20.105)"
        >
          <g id="ic_no_contract_svg__Group_495" data-name="Group 495">
            <path
              id="ic_no_contract_svg__Path_492"
              data-name="Path 492"
              className="ic_no_contract_svg__cls-4"
              d="M153.715 84h-16.1a1.61 1.61 0 000 3.221h16.1a1.61 1.61 0 100-3.221z"
              transform="translate(-136 -84)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_498"
          data-name="Group 498"
          transform="translate(12.884 39.431)"
        >
          <g id="ic_no_contract_svg__Group_497" data-name="Group 497">
            <path
              id="ic_no_contract_svg__Path_493"
              data-name="Path 493"
              className="ic_no_contract_svg__cls-4"
              d="M75.273 180H65.61a1.61 1.61 0 000 3.221h9.663a1.61 1.61 0 000-3.221z"
              transform="translate(-64 -180)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_500"
          data-name="Group 500"
          transform="translate(28.989 39.431)"
        >
          <g id="ic_no_contract_svg__Group_499" data-name="Group 499">
            <path
              id="ic_no_contract_svg__Path_494"
              data-name="Path 494"
              className="ic_no_contract_svg__cls-4"
              d="M181.041 180H145.61a1.61 1.61 0 000 3.221h35.431a1.61 1.61 0 000-3.221z"
              transform="translate(-144 -180)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_502"
          data-name="Group 502"
          transform="translate(6.442 45.873)"
        >
          <g id="ic_no_contract_svg__Group_501" data-name="Group 501">
            <path
              id="ic_no_contract_svg__Path_495"
              data-name="Path 495"
              className="ic_no_contract_svg__cls-4"
              d="M91.588 212H33.61a1.61 1.61 0 100 3.221h57.978a1.61 1.61 0 100-3.221z"
              transform="translate(-32 -212)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_504"
          data-name="Group 504"
          transform="translate(6.442 52.315)"
        >
          <g id="ic_no_contract_svg__Group_503" data-name="Group 503">
            <path
              id="ic_no_contract_svg__Path_496"
              data-name="Path 496"
              className="ic_no_contract_svg__cls-4"
              d="M75.483 244H33.61a1.61 1.61 0 000 3.221h41.873a1.61 1.61 0 000-3.221z"
              transform="translate(-32 -244)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_506"
          data-name="Group 506"
          transform="translate(54.756 52.315)"
        >
          <g id="ic_no_contract_svg__Group_505" data-name="Group 505">
            <path
              id="ic_no_contract_svg__Path_497"
              data-name="Path 497"
              className="ic_no_contract_svg__cls-4"
              d="M283.273 244h-9.663a1.61 1.61 0 000 3.221h9.663a1.61 1.61 0 000-3.221z"
              transform="translate(-272 -244)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_508"
          data-name="Group 508"
          transform="translate(35.431 58.756)"
        >
          <g id="ic_no_contract_svg__Group_507" data-name="Group 507">
            <path
              id="ic_no_contract_svg__Path_498"
              data-name="Path 498"
              className="ic_no_contract_svg__cls-4"
              d="M206.6 276h-28.99a1.61 1.61 0 100 3.221h28.99a1.61 1.61 0 100-3.221z"
              transform="translate(-176 -276)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_510"
          data-name="Group 510"
          transform="translate(6.442 58.756)"
        >
          <g id="ic_no_contract_svg__Group_509" data-name="Group 509">
            <path
              id="ic_no_contract_svg__Path_499"
              data-name="Path 499"
              className="ic_no_contract_svg__cls-4"
              d="M56.157 276H33.61a1.61 1.61 0 100 3.221h22.547a1.61 1.61 0 100-3.221z"
              transform="translate(-32 -276)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_512"
          data-name="Group 512"
          transform="translate(57.977 65.198)"
        >
          <g id="ic_no_contract_svg__Group_511" data-name="Group 511">
            <path
              id="ic_no_contract_svg__Path_500"
              data-name="Path 500"
              className="ic_no_contract_svg__cls-4"
              d="M296.052 308h-6.442a1.61 1.61 0 000 3.221h6.442a1.61 1.61 0 000-3.221z"
              transform="translate(-288 -308)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_514"
          data-name="Group 514"
          transform="translate(6.442 65.198)"
        >
          <g id="ic_no_contract_svg__Group_513" data-name="Group 513">
            <path
              id="ic_no_contract_svg__Path_501"
              data-name="Path 501"
              className="ic_no_contract_svg__cls-4"
              d="M41.663 308H33.61a1.61 1.61 0 100 3.221h8.052a1.61 1.61 0 100-3.221z"
              transform="translate(-32 -308)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_516"
          data-name="Group 516"
          transform="translate(20.936 65.198)"
        >
          <g id="ic_no_contract_svg__Group_515" data-name="Group 515">
            <path
              id="ic_no_contract_svg__Path_502"
              data-name="Path 502"
              className="ic_no_contract_svg__cls-4"
              d="M136.21 308h-30.6a1.61 1.61 0 000 3.221h30.6a1.61 1.61 0 000-3.221z"
              transform="translate(-104 -308)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_518"
          data-name="Group 518"
          transform="translate(40.262 84.524)"
        >
          <g id="ic_no_contract_svg__Group_517" data-name="Group 517">
            <path
              id="ic_no_contract_svg__Path_503"
              data-name="Path 503"
              className="ic_no_contract_svg__cls-4"
              d="M224.157 404H201.61a1.61 1.61 0 100 3.221h22.547a1.61 1.61 0 100-3.221z"
              transform="translate(-200 -404)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_520"
          data-name="Group 520"
          transform="translate(20.936 13.663)"
        >
          <g id="ic_no_contract_svg__Group_519" data-name="Group 519">
            <path
              id="ic_no_contract_svg__Path_504"
              data-name="Path 504"
              className="ic_no_contract_svg__cls-4"
              d="M134.6 52h-28.99a1.61 1.61 0 000 3.221h28.99a1.61 1.61 0 100-3.221z"
              transform="translate(-104 -52)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_522"
          data-name="Group 522"
          transform="translate(77.303 12.052)"
        >
          <g id="ic_no_contract_svg__Group_521" data-name="Group 521">
            <path
              id="ic_no_contract_svg__Path_505"
              data-name="Path 505"
              className="ic_no_contract_svg__cls-4"
              d="M401.715 50.442h-4.831a6.442 6.442 0 10-12.884 0v57.977a17.043 17.043 0 005.028 12.137l.275.275a1.61 1.61 0 002.277 0l.275-.275a17.043 17.043 0 005.028-12.137V53.663h3.217v14.494h3.221v-16.1a1.611 1.611 0 00-1.606-1.615zm-11.273 66.893a13.81 13.81 0 01-3.129-7.305h6.258a13.811 13.811 0 01-3.129 7.305zm3.221-10.526h-6.442V53.663h6.442zm-6.442-56.367a3.221 3.221 0 016.442 0z"
              transform="translate(-384 -44)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_524"
          data-name="Group 524"
          transform="translate(45.094 29.768)"
        >
          <g id="ic_no_contract_svg__Group_523" data-name="Group 523">
            <path
              id="ic_no_contract_svg__Path_506"
              data-name="Path 506"
              className="ic_no_contract_svg__cls-4"
              d="M244.936 132H225.61a1.61 1.61 0 000 3.221h19.326a1.61 1.61 0 100-3.221z"
              transform="translate(-224 -132)"
            />
          </g>
        </g>
        <g
          id="ic_no_contract_svg__Group_526"
          data-name="Group 526"
          transform="translate(6.442 71.64)"
        >
          <g id="ic_no_contract_svg__Group_525" data-name="Group 525">
            <path
              id="ic_no_contract_svg__Path_507"
              data-name="Path 507"
              className="ic_no_contract_svg__cls-4"
              d="M69.041 340H33.61a1.61 1.61 0 000 3.221h35.431a1.61 1.61 0 100-3.221z"
              transform="translate(-32 -340)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgIcNoContract;
